import { IValidator, Validations } from '@samc/centricity-core';
import { IServicerGroup } from '../Components/ServicerSelector';

export class ServicerGroupValidator implements IValidator<IServicerGroup> {
  public isValid(value: IServicerGroup): Validations<IServicerGroup> {
    const validations: Validations<IServicerGroup> = {};

    if (value.servicerId === null || value.servicerId.length === 0) validations.servicerId = 'Servicer is required!';
    return validations;
  }
}